import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsDevCardRedesignEnabled } from '../../../../selectors';
import { trackDeveloperCardLinkClick } from '../../../../tracking/newbuilding';
import { IBuilder } from '../../../../types/newbuildingHeader';
import { DataItem } from '../DataItem';

interface IDeveloperProps {
  developer: IBuilder;
}

export const Developer: React.FC<IDeveloperProps> = ({ developer }) => {
  const isDevCardEnabled = useSelector(selectIsDevCardRedesignEnabled);

  const url = React.useMemo(
    () => (isDevCardEnabled ? developer.profileUrl : undefined),
    [isDevCardEnabled, developer.profileUrl],
  );

  return (
    <DataItem
      image={developer.logoUrl}
      header="Застройщик"
      text={developer.name}
      url={url}
      onClick={trackDeveloperCardLinkClick}
    />
  );
};
